import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ContentComponentForBottomSheetComponent } from 'ib/internetbank-core/ib-components/pop-ups/bottom-sheet/bottom-sheet.component';
import { BonusCodes } from 'ib/internetbank-core/ib-models/bonus-code.enum';

import { ProductId } from '../../../../../../../common/models/product-id';


@Component({
	selector: 'app-bonus-transfer-type-bottom-sheet',
	templateUrl: './bonus-transfer-type.content-component-for-bottom-sheet-component.component.html',
	styleUrls: ['./bonus-transfer-type.content-component-for-bottom-sheet-component.component.less'],
	imports: [RouterModule],
})
export class BonusTransferTypeBottomSheetComponent extends ContentComponentForBottomSheetComponent {

	@Input({ required: true })
	public productId: ProductId;

	@Input({ required: true })
	public programId: BonusCodes;

	public close(): void {
		this.closePopup?.();
	}

}
